import React from 'react'
import withStyles from 'react-jss'
import PropTypes from 'prop-types'

import previewExpiredStyles from './preview-expired-style'

const PreviewExpired = props =>
  <div className={props.classes.overlay}>
    <p className={props.classes.text}>Erreur preview. Rechargez Wicare.</p>
  </div>

PreviewExpired.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(previewExpiredStyles)(PreviewExpired)
